import { Grid, Typography, Box, Button, IconButton } from "@mui/material";
import OptionMenu from "../optionMenu/optionMenu";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import React from "react";
import { Participant } from "../../interfaces/interfaces";
import { SearchParticipantContext } from "../../context/searchParticipantContext";
import { User, AppContext } from "../../../../context/appContext";
import checkPermissionAdmin from "../../../../functions/checkPermissionAdmin";

const ListTileHead = ({
  participant,
}: {
  participant: Participant;
}): React.JSX.Element => {
  const {
    setShowFileDialog,
    showParticipantDetails,
  }: {
    setShowFileDialog: (showFileDialog: any) => void;
    showParticipantDetails: (participant: Participant) => void;
  } = React.useContext(SearchParticipantContext);

  const {
    user,
  }: {
    user: User;
  } = React.useContext(AppContext);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Typography variant="caption" color="span">
          Name, Vorname
        </Typography>
        <br />
        <Typography variant="body1" color="initial">
          {participant.fullName}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          justifyContent: {
            xs: "center",
            md: "flex-end",
          },
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            mr: 3,
          }}
        >
          <Typography variant="caption" color="span">
            Status
          </Typography>
          <br />
          <Typography
            variant="body1"
            color={
              participant.status === 0
                ? (theme) => theme.palette.success.main
                : (theme) => theme.palette.error.main
            }
          >
            {participant.status === 0 ? "aktiv" : "inaktiv"}
          </Typography>
        </Box>

        <Button
          sx={{
            mr: 2,
          }}
          endIcon={<FileUploadOutlinedIcon />}
          variant="outlined"
          color="primary"
          onClick={() =>
            setShowFileDialog({
              open: true,
              participant: participant,
            })
          }
        >
          Unterlagen
        </Button>

        {checkPermissionAdmin(user) && <OptionMenu participant={participant} />}

        <IconButton
          aria-label=""
          onClick={() => {
            showParticipantDetails(participant);
          }}
        >
          {
            <KeyboardArrowUpOutlinedIcon
              sx={{
                transition: "transform 0.3s",
                transform: participant.collapse
                  ? "rotate(0deg)"
                  : "rotate(180deg)",
              }}
            />
          }
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default ListTileHead;
